/**
 * GUFUMART cart sync — Shopify /cart.js is the only source of truth.
 * Updates the header quantity badge without replacing the bag icon markup.
 */
(function (window) {
  'use strict';

  if (window.GufumartCartSync) return;

  var syncPromise = null;
  var listenersBound = false;

  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function cartJsUrl() {
    return cartRoot().replace(/\/?$/, '/') + 'cart.js';
  }

  function getBubble() {
    return document.getElementById('cart-icon-bubble');
  }

  function isGufumartBagIcon(bubble) {
    return !!(
      bubble &&
      (bubble.classList.contains('gf-product-page-header__bag') ||
        bubble.querySelector('.gf-pdp-icon, .gf-pdp-icon--bag'))
    );
  }

  /**
   * Update only the quantity badge inside #cart-icon-bubble.
   * Never replaces SVG / icon markup.
   */
  function updateHeaderCount(itemCount) {
    var bubble = getBubble();
    if (!bubble) return;

    var count = parseInt(itemCount, 10);
    if (isNaN(count) || count < 0) count = 0;

    var badge = bubble.querySelector('.cart-count-bubble');

    if (count === 0) {
      if (badge) badge.remove();
      return;
    }

    if (!badge) {
      badge = document.createElement('div');
      badge.className = 'cart-count-bubble';
      badge.innerHTML =
        '<span aria-hidden="true"></span>' +
        '<span class="visually-hidden">Cart items</span>';
      bubble.appendChild(badge);
    }

    var num = badge.querySelector('[aria-hidden="true"]');
    var sr = badge.querySelector('.visually-hidden');
    if (num) {
      if (count < 100) {
        num.textContent = String(count);
        num.removeAttribute('hidden');
      } else {
        num.textContent = '';
      }
    }
    if (sr) {
      sr.textContent = count === 1 ? '1 item' : count + ' items';
    }
  }

  function fetchCart() {
    return fetch(cartJsUrl(), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    }).then(function (response) {
      if (!response.ok) throw new Error('cart.js failed');
      return response.json();
    });
  }

  /**
   * Fetch /cart.js and refresh the header badge.
   * Resolves with the cart object (or null on failure).
   */
  function sync() {
    if (syncPromise) return syncPromise;

    syncPromise = fetchCart()
      .then(function (cart) {
        if (cart && typeof cart.item_count !== 'undefined') {
          updateHeaderCount(cart.item_count);
        }
        return cart;
      })
      .catch(function () {
        return null;
      })
      .finally(function () {
        syncPromise = null;
      });

    return syncPromise;
  }

  function cartHasVariant(cart, variantId) {
    if (!cart || !cart.items || !variantId) return false;
    var id = String(variantId);
    return cart.items.some(function (item) {
      return String(item.variant_id) === id || String(item.id) === id;
    });
  }

  function bindLifecycleListeners() {
    if (listenersBound) return;
    listenersBound = true;

    var onActivate = function () {
      sync().then(function (cart) {
        document.dispatchEvent(
          new CustomEvent('gufumart:cart-synced', {
            detail: { cart: cart },
            bubbles: true,
          })
        );
      });
    };

    window.addEventListener('pageshow', onActivate);
    window.addEventListener('popstate', onActivate);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') onActivate();
    });
  }

  window.GufumartCartSync = {
    fetchCart: fetchCart,
    sync: sync,
    updateHeaderCount: updateHeaderCount,
    cartHasVariant: cartHasVariant,
    isGufumartBagIcon: isGufumartBagIcon,
    bindLifecycleListeners: bindLifecycleListeners,
  };

  bindLifecycleListeners();
})(window);
